<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.85492 5.13333C5.11492 5.39333 5.11492 5.80667 4.85492 6.06667L3.58825 7.33333H9.72159C10.0883 7.33333 10.3883 7.63333 10.3883 8C10.3883 8.36667 10.0883 8.66667 9.72159 8.66667H3.58825L4.85492 9.93333C5.11492 10.1933 5.11492 10.6067 4.85492 10.8667C4.59492 11.1267 4.18159 11.1267 3.92159 10.8667L1.52825 8.47333C1.26825 8.21333 1.26825 7.79333 1.52825 7.53333L3.92159 5.13333C4.18159 4.87333 4.59492 4.87333 4.85492 5.13333ZM13.3333 12.6667H8.66659C8.29992 12.6667 7.99992 12.9667 7.99992 13.3333C7.99992 13.7 8.29992 14 8.66659 14H13.3333C14.0666 14 14.6666 13.4 14.6666 12.6667V3.33333C14.6666 2.6 14.0666 2 13.3333 2H8.66659C8.29992 2 7.99992 2.3 7.99992 2.66667C7.99992 3.03333 8.29992 3.33333 8.66659 3.33333H13.3333V12.6667Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    color: { type: String, default: '' },
  },
}
</script>
